import { find } from 'lodash';
import { useState } from 'react';
import { Form, Input, Modal, Select, message } from 'antd';
import { useConcent } from 'concent';

import { LOGIN_TYPE, PANGU_RTX_ROLE_ID_MAP, PANGU_WX_ROLE_ID_MAP } from 'configs/constant/common';

type IProps = {
  isShowModal: boolean;
  hideApplyModal: Function;
};

const ApplyAuthModal = (props: IProps) => {
  const userCtx = useConcent({ module: 'user' });
  const { userName, accountType, roleList } = userCtx.state;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [addModalForm] = Form.useForm();
  const PANGU_ROLE_ID_MAP = accountType === LOGIN_TYPE.rtx ? PANGU_RTX_ROLE_ID_MAP : PANGU_WX_ROLE_ID_MAP;
  const applyOptions = Object.values(PANGU_ROLE_ID_MAP).map((item: any) => {
    const baseOption = {
      key: item.value,
      label: item.label,
      value: item.value,
    };
    if (roleList && find(roleList, { roleId: item.value })) {
      return {
        ...baseOption,
        disabled: true,
      };
    } else {
      return baseOption;
    }
  });

  const applyAuth = async () => {
    try {
      await addModalForm.validateFields();
    } catch (error) {
      return;
    }
    try {
      const formData = addModalForm.getFieldsValue();
      const param = {
        userName,
        comment: formData.comment,
        userAuths: formData.role_list,
      };
      setConfirmLoading(true);
      const res = await userCtx?.dispatch('appendAuth', param);
      setConfirmLoading(false);
      if (res && res.code === 0) {
        message.success('等待审批，请稍晚刷新重试');
        onModalClose();
      }
    } catch (error) {
      setConfirmLoading(false);
      message.error(`申请失败！失败信息：${error.message || error.msg}`);
    }
  };

  const onModalClose = () => {
    addModalForm.resetFields();
    props.hideApplyModal();
  };

  return (
    <Modal
      open={props.isShowModal}
      title='权限申请'
      width={620}
      destroyOnHidden={true}
      onOk={applyAuth}
      onCancel={onModalClose}
      confirmLoading={confirmLoading}
    >
      <Form form={addModalForm} labelCol={{ span: 5 }} wrapperCol={{ span: 19 }} labelAlign='right'>
        <Form.Item
          label='角色'
          tooltip={`已有角色：${roleList?.map((item: { name: string; roleId: number }) => item.name).join('，')}`}
          name='role_list'
          rules={[{ required: true, message: '请选择角色，可多选' }]}
        >
          <Select
            mode='multiple'
            allowClear
            className='width430'
            placeholder='请选择角色，可多选'
            options={applyOptions}
          />
        </Form.Item>
        <Form.Item label='申请原因' name='comment' rules={[{ required: true, message: '请输入申请原因' }]}>
          <Input.TextArea
            placeholder='请输入申请原因'
            allowClear
            className='width430'
            maxLength={1000}
            autoSize={{ minRows: 4 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ApplyAuthModal;
